/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AdminPanelOverviewQueryVariables = {
    orgRelayId: string;
};
export type AdminPanelOverviewQueryResponse = {
    readonly org: {
        readonly id?: string | undefined;
        readonly orgOverview?: ({
            readonly __typename: "GraphEntityError";
            readonly statusCode: number | null;
            readonly message: string | null;
        } | {
            readonly __typename: "OrgOverview";
            readonly userCount: ReadonlyArray<{
                readonly label: string;
                readonly value: number;
            }>;
            readonly scheduleAssistCount: ReadonlyArray<{
                readonly label: string;
                readonly value: number;
            }>;
            readonly scheduleAssistLimit: number;
            readonly focusTimeHoursCreatedCount: ReadonlyArray<{
                readonly label: string;
                readonly value: number;
            }>;
            readonly conflictsResolvedCount: ReadonlyArray<{
                readonly label: string;
                readonly value: number;
            }>;
            readonly numUsersByRole: ReadonlyArray<{
                readonly label: string;
                readonly value: number;
            }>;
            readonly numUsersByFunction: ReadonlyArray<{
                readonly label: string;
                readonly value: number;
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null | undefined;
    } | null;
};
export type AdminPanelOverviewQuery = {
    readonly response: AdminPanelOverviewQueryResponse;
    readonly variables: AdminPanelOverviewQueryVariables;
};



/*
query AdminPanelOverviewQuery(
  $orgRelayId: ID!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      id
      orgOverview {
        __typename
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on OrgOverview {
          userCount {
            label
            value
          }
          scheduleAssistCount {
            label
            value
          }
          scheduleAssistLimit
          focusTimeHoursCreatedCount {
            label
            value
          }
          conflictsResolvedCount {
            label
            value
          }
          numUsersByRole {
            label
            value
          }
          numUsersByFunction {
            label
            value
          }
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v4 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any
    ], v5 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "orgOverview",
        "plural": false,
        "selections": [
            (v3 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                    }
                ],
                "type": "GraphEntityError",
                "abstractKey": null
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntegerDataPoint",
                        "kind": "LinkedField",
                        "name": "userCount",
                        "plural": true,
                        "selections": (v4 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntegerDataPoint",
                        "kind": "LinkedField",
                        "name": "scheduleAssistCount",
                        "plural": true,
                        "selections": (v4 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "scheduleAssistLimit",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntegerDataPoint",
                        "kind": "LinkedField",
                        "name": "focusTimeHoursCreatedCount",
                        "plural": true,
                        "selections": (v4 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntegerDataPoint",
                        "kind": "LinkedField",
                        "name": "conflictsResolvedCount",
                        "plural": true,
                        "selections": (v4 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntegerDataPoint",
                        "kind": "LinkedField",
                        "name": "numUsersByRole",
                        "plural": true,
                        "selections": (v4 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntegerDataPoint",
                        "kind": "LinkedField",
                        "name": "numUsersByFunction",
                        "plural": true,
                        "selections": (v4 /*: any*/),
                        "storageKey": null
                    }
                ],
                "type": "OrgOverview",
                "abstractKey": null
            }
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AdminPanelOverviewQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v2 /*: any*/),
                                (v5 /*: any*/)
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AdminPanelOverviewQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v5 /*: any*/)
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "0806a69756b08c63f0ff800ed2b8f854",
            "id": null,
            "metadata": {},
            "name": "AdminPanelOverviewQuery",
            "operationKind": "query",
            "text": "query AdminPanelOverviewQuery(\n  $orgRelayId: ID!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      id\n      orgOverview {\n        __typename\n        ... on GraphEntityError {\n          statusCode\n          message\n        }\n        ... on OrgOverview {\n          userCount {\n            label\n            value\n          }\n          scheduleAssistCount {\n            label\n            value\n          }\n          scheduleAssistLimit\n          focusTimeHoursCreatedCount {\n            label\n            value\n          }\n          conflictsResolvedCount {\n            label\n            value\n          }\n          numUsersByRole {\n            label\n            value\n          }\n          numUsersByFunction {\n            label\n            value\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '7db3aed4197f6504f7fe2c5925a28151';
export default node;
